import React, { useState, useEffect } from "react";
import { CButton, CBadge, CDataTable, CInput, CRow, CCol } from "@coreui/react";
import { useDispatch, useSelector } from "react-redux";
import CIcon from "@coreui/icons-react";
import { fetchList, blockUnblockRequest } from "src/store/actions/admin";
import { getBadge, confirmModal, hasPermission } from "src/utils/helper";
import { defaultLimitPerPage, MODULES, PERMISSIONS } from "src/utils/constants";
import PageContainer from "src/components/PageContainer";
import { ROUTES } from "src/router/routes";
// import FormInput from "src/components/FormInput";

const type = "tags";

const Tags = ({ history }) => {
  const dispatch = useDispatch();
  const {
    loading,
    data: { data: tagsList, count: total },
  } = useSelector((state) => state.admin.tags);
  const message = useSelector((state) => state.admin.modal);
  const [search, setSearch] = useState("");
  const [searchFilter, setSearchFilter] = useState("");
  const [limitPerPage, setLimitPerPage] = useState(defaultLimitPerPage);
  const [page, setPage] = useState(1);
  const totalpage = Math.ceil(total / limitPerPage);

  const pageChange = (newPage) => {
    if (newPage !== 0) setPage(newPage);
  };

  useEffect(() => {
    dispatch(
      fetchList(type, {
        skip: (page - 1) * limitPerPage,
        limit: limitPerPage,
        search: searchFilter,
      })
    );
  }, [dispatch, page, message, limitPerPage, searchFilter]);

  const searchHandler = (e) => {
    e.preventDefault();
    setSearchFilter(search);
  };

  const blockUnblock = (e, item) => {
    e.stopPropagation();
    confirmModal(item.status, (status) =>
      dispatch(
        blockUnblockRequest(type, {
          tag_id: item._id,
          status,
        })
      )
    );
  };

  const deleteTag = (e, item) => {
    e.stopPropagation();
    confirmModal(
      item.status,
      () =>
        dispatch(
          blockUnblockRequest(type, {
            tag_id: item._id,
            status: 2,
          })
        ),
      "Delete",
      "Delete"
    );
  };

  return (
    <PageContainer
      title="Tags"
      rightButtons={
        hasPermission(MODULES.PRODUCTS, PERMISSIONS.WRITE)
          ? [
              {
                label: "Add Tag",
                onClick: () => history.push(`${ROUTES.TAGS}${ROUTES.ADD}`),
              },
            ]
          : []
      }
      pagination={{
        activePage: page,
        onActivePageChange: pageChange,
        pages: totalpage,
        setLimitPerPage,
      }}
      loading={loading}
    >
      <CRow className={"mb-2"}>
        <CCol sm={3}>
          Search
          <form onSubmit={searchHandler}>
            <CInput
              placeholder="press enter to search.."
              value={search}
              name="search"
              onChange={(e) => setSearch(e.target.value)}
            />
          </form>
        </CCol>
        <CCol sm={1}>
          <CButton
            color="primary"
            variant="outline"
            size="sm"
            className="resetButton"
            onClick={() => {
              setSearch("");
              setSearchFilter("");
            }}
          >
            Reset
          </CButton>
        </CCol>
      </CRow>

      <CDataTable
        items={tagsList}
        fields={[
          "sr_no",
          {
            key: "actions",
            label: "Actions",
            sorter: false,
            filter: false,
          },
          "status",
          "tag_name",
        ]}
        hover
        clickableRows
        loading={loading}
        addTableClasses={"default"}
        onRowClick={(item) => {
          if (hasPermission(MODULES.PRODUCTS, PERMISSIONS.WRITE)) {
            history.push(`${ROUTES.TAGS}${ROUTES.EDIT}`, item);
          }
        }}
        scopedSlots={{
          sr_no: (_, index) => (
            <td>{limitPerPage * (page - 1) + (index + 1)}</td>
          ),
          status: (item) => (
            <td>
              <CBadge color={getBadge(item.status)}>
                {item.status === 1 ? "Active" : "Inactive"}
              </CBadge>
            </td>
          ),
          actions: (item) =>
            hasPermission(MODULES.PRODUCTS, PERMISSIONS.WRITE) ? (
              <td className="py-2">
                <CButton color="primary" variant="outline" size="sm">
                  <CIcon name="cil-pencil" /> Edit
                </CButton>
                <CButton
                  className={"ml-2"}
                  color={item.status ? "danger" : "primary"}
                  variant="outline"
                  size="sm"
                  onClick={(e) => blockUnblock(e, item)}
                >
                  <CIcon
                    name={item.status ? "cil-x-circle" : "cil-check-circle"}
                  />
                  {item.status ? " Block" : " Unblock"}
                </CButton>
                <CButton
                  className={"ml-2"}
                  color={"danger"}
                  variant="outline"
                  size="sm"
                  onClick={(e) => deleteTag(e, item)}
                >
                  <CIcon name="cil-trash" />
                  Delete
                </CButton>
              </td>
            ) : (
              <td>-</td>
            ),
        }}
      />
    </PageContainer>
  );
};

export default Tags;
